import { render } from "./Flash.vue?vue&type=template&id=5cd1480c"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"

import "./Flash.vue?vue&type=style&index=0&id=5cd1480c&lang=css"

import exportComponent from "/home/samuel/Dokumente/Webtheke/Projekte/zeiterfassungstool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__